import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { WizButton, WizNavigationManager, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { RouteEngine } from 'src/app/manager/routing/route.engine';

/**
 * Vue d'acceuil de la gestion des données dans une bu
 */
@Component({
  selector: 'dashboard-data-view',
  templateUrl: './dashboard-data.view.html',
})
export class DashboardDataView extends BaseView {
  /** Bouton "choisir mon application modèle" */
  @ViewChild('btnAppModel', { read: WizButton, static: false }) btnAppModel: WizButton;
  /** Bouton "en savoir plus sur les chronocodes" */
  @ViewChild('btnMoreChrono', { read: WizButton, static: false }) btnMoreChrono: WizButton;
  /** Bouton " en savoir plus sur les mesures" */
  @ViewChild('btnMoreMeasures', { read: WizButton, static: false }) btnMoreMeasures: WizButton;
  /** Bouton "en savoir plus sur les codifications" */
  @ViewChild('btnMoreCodif', { read: WizButton, static: false }) btnMoreCodif: WizButton;

  /**
   * Constructeur
   * @param elementRef elementRef pour pose d'écouteurs
   */
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  /**
   * Mise en place des écouteurs
   */
  public wizAddListener(): void {
    super.wizAddListener();

    // click sur les hyper lien
    WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.CLICK, this.clickHandler);
  }

  /**
   * Suppression des écouteurs
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.elementRef, WIZ_EVENT_TYPE.CLICK);
  }

  /**
   * Gestion du click sur les boutons hyper lien pour la redirection
   * @param event wizEvent
   */
  public clickHandler(event: WizEvent): void {
    const target = event.component;
    switch (target) {
      case this.btnAppModel:
        // TODO
        break;
      case this.btnMoreChrono:
        this.goToView(RouteEngine.CHRONO_VIEW);
        break;
      case this.btnMoreMeasures:
        this.goToView(RouteEngine.MEASURE_VIEW);
        break;
      case this.btnMoreCodif:
        this.goToView(RouteEngine.FREE_DATA_VIEW);
        break;
      default:
        break;
    }
  }

  /**
   * navigation vers la vue des données en paramètre
   * @param name nom de la vue de destination
   */
  public goToView(name: string): void {
    WizNavigationManager.navigate(name);
  }
}
